import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ICONS } from "../../../utils/fontawesome";

const formatHoraire = (start, end) => {
    const normalize = (time) => {
      if (!time) return null;
      if (/^\d{2}:\d{2}$/.test(time)) return `${time}:00`;
      if (/^\d{2}:\d{2}:\d{2}$/.test(time)) return time;
      if (/^\d{1,2}$/.test(time)) return `${String(time).padStart(2, "0")}:00:00`;
      return null;
    };
    const label = (time) => {
      if (!time) return "--";
      const [h = "00", m = "00"] = time.split(":");
      return `${h}h${m}`;
    };
    const startNorm = normalize(start);
    const endNorm = normalize(end);
  if (startNorm && endNorm) return `${label(startNorm)} - ${label(endNorm)}`;
  if (startNorm) return `${label(startNorm)}`;
  return "--";
};

const getStartSeconds = (resa) => {
  const time = resa.creneau_heure_debut || resa.heure_debut || resa.heure;
  if (time === null || time === undefined || time === "") return Number.MAX_SAFE_INTEGER;
  if (typeof time === "number") return time * 3600;
  if (/^\d{1,2}$/.test(time)) return Number(time) * 3600;
  const [h = "0", m = "0", s = "0"] = String(time).split(":");
  return Number(h) * 3600 + Number(m) * 60 + Number(s);
};

const ReservationDayList = ({ reservations = [] }) => {
  if (!reservations.length) {
    return (
      <div className="border border-dashed border-slate-200 rounded-lg p-3 text-sm text-slate-500">
        Aucune réservation pour cette date.
      </div>
    );
  }
  const sortedReservations = [...reservations].sort(
    (a, b) => getStartSeconds(a) - getStartSeconds(b)
  );
  return (
    <div className="flex flex-col gap-2">
      {sortedReservations.map((resa, idx) => {
        const tables = Array.isArray(resa.block) ? resa.block.length : resa.nombre_table || 0;
        const persons = Number(resa.nombre_inscrit) || Number(resa.nombre_reservation) || 0;
        const horaire = formatHoraire(
          resa.creneau_heure_debut || resa.heure_debut || resa.heure,
          resa.creneau_heure_fin || resa.heure_fin || resa.fin
        );
        return (
          <div
            key={resa.creneau_id || resa.id || idx}
            className="flex items-center justify-between border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-700"
          >
            <div className="flex items-center gap-3">
              <span className="font-semibold">{horaire}</span>
              <span className="text-slate-500">
                {tables} table{tables > 1 ? "s" : ""}, {persons} personne{persons > 1 ? "s" : ""}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReservationDayList;
